import type { MobileCategoryTilesConfig } from '@/lib/sections/types';
import { CmsSchema, useCmsFields } from '@/cms/content';
import { homeThumbnail } from '@/lib/homeThumbnail';

/** Mobile-only horizontal row of 5 vertical category tiles. */
export function MobileCategoryTiles({ config }: { config: MobileCategoryTilesConfig }) {
  const { tiles } = config;
  const cms = useCmsFields(tiles.flatMap((tile, i) => [
    { key: `home.mobileCategories.${i}.title`, label: 'Tytuł', section: `Kategoria ${i + 1} na telefonie`, kind: 'text' as const, defaultValue: tile.title, required: true },
    { key: `home.mobileCategories.${i}.image`, label: 'Zdjęcie', section: `Kategoria ${i + 1} na telefonie`, kind: 'image' as const, defaultValue: tile.image, required: true },
    { key: `home.mobileCategories.${i}.alt`, label: 'Opis zdjęcia', section: `Kategoria ${i + 1} na telefonie`, kind: 'alt' as const, defaultValue: tile.title },
  ]));
  return (
    <section aria-label="Kategorie" className="md:hidden" style={{ padding: '6px 0 0' }}>
      <CmsSchema fields={cms.fields} />
      <div
        className="no-scrollbar"
        style={{
          display: 'flex', gap: 10,
          overflowX: 'auto',
          WebkitOverflowScrolling: 'touch',
          padding: '0 clamp(16px, 4vw, 24px) 12px',
        }}
      >
        {tiles.map((tile, i) => (
          <a
            key={tile.title}
            href={tile.href}
            aria-labelledby={`home-mobile-category-${i}`}
            data-testid={`mobile-category-${tile.title}`}
            style={{
              position: 'relative',
              flex: '0 0 auto',
              width: 108,
              aspectRatio: '3 / 4.4',
              borderRadius: 14,
              overflow: 'hidden',
              textDecoration: 'none',
              boxShadow: '0 2px 10px rgba(42,31,20,0.10)',
            }}
          >
            <img
              {...cms.image(`home.mobileCategories.${i}.image`)}
              {...cms.alt(`home.mobileCategories.${i}.alt`)}
              {...homeThumbnail(cms.value(`home.mobileCategories.${i}.image`), '108px')}
              alt={cms.value(`home.mobileCategories.${i}.alt`)}
              loading="lazy"
              fetchPriority="low"
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <span
              aria-hidden
              style={{
                position: 'absolute', left: 0, right: 0, bottom: 0, height: '55%',
                background: 'linear-gradient(to top, rgba(20,14,8,0.72) 0%, rgba(20,14,8,0.32) 55%, transparent 100%)',
              }}
            />
            <span id={`home-mobile-category-${i}`} {...cms.text(`home.mobileCategories.${i}.title`)} style={{
              position: 'absolute', left: 8, right: 8, bottom: 9,
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 13, fontWeight: 600, lineHeight: 1.25,
              color: '#fff', letterSpacing: '0.02em',
              textAlign: 'center',
            }}>
              {cms.value(`home.mobileCategories.${i}.title`)}
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
